import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Mail, MessageCircle, Phone, Instagram, Facebook, MapPin } from "lucide-react";
import { Navbar } from "../components/Navbar";
import { api } from "../lib/api";

export default function ContactsPage() {
  const [c, setC] = useState(null);

  useEffect(() => {
    api.get("/settings").then((r) => setC(r.data.contacts)).catch(() => setC({}));
  }, []);

  const items = c
    ? [
        c.email && { icon: Mail, label: "Email", value: c.email, href: `mailto:${c.email}`, color: "#00F0FF" },
        c.whatsapp && { icon: MessageCircle, label: "WhatsApp", value: c.whatsapp, href: `https://wa.me/${c.whatsapp.replace(/[^0-9]/g, "")}`, color: "#39FF14" },
        c.phone && { icon: Phone, label: "Telefono", value: c.phone, href: `tel:${c.phone}`, color: "#FFE600" },
        c.instagram && { icon: Instagram, label: "Instagram", value: c.instagram, href: c.instagram.startsWith("http") ? c.instagram : `https://instagram.com/${c.instagram.replace("@", "")}`, color: "#FF007F" },
        c.facebook && { icon: Facebook, label: "Facebook", value: c.facebook, href: c.facebook.startsWith("http") ? c.facebook : `https://facebook.com/${c.facebook}`, color: "#A855F7" },
        c.location && { icon: MapPin, label: "Dove sono", value: c.location, href: null, color: "#00F0FF" },
      ].filter(Boolean)
    : [];

  return (
    <div className="noise-overlay min-h-screen">
      <Navbar />
      <div className="max-w-3xl mx-auto px-5 sm:px-8 py-16">
        <span className="font-mono text-xs uppercase tracking-widest text-neon-green">Parliamone</span>
        <h1 className="font-display font-black text-4xl sm:text-5xl tracking-tighter text-white mt-2">
          Contatti <span className="text-neon-pink drop-shadow-[0_0_14px_rgba(255,0,127,0.5)]">diretti</span>
        </h1>
        {c?.intro && <p className="text-muted-foreground font-light mt-3 max-w-lg">{c.intro}</p>}

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-10">
          {items.length === 0 ? (
            <p data-testid="contacts-empty" className="font-mono text-muted-foreground col-span-2">Contatti non ancora configurati.</p>
          ) : (
            items.map((it, i) => {
              const Comp = it.href ? "a" : "div";
              return (
                <motion.div key={it.label} initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.07 }}>
                  <Comp
                    data-testid={`contact-${it.label.toLowerCase()}`}
                    {...(it.href ? { href: it.href, target: "_blank", rel: "noreferrer" } : {})}
                    className="group flex items-center gap-4 p-5 bg-card border border-white/10 rounded-sm hover:-translate-y-1 transition-transform duration-300"
                    style={{ boxShadow: "none" }}
                  >
                    <span className="w-12 h-12 flex items-center justify-center rounded-sm border shrink-0" style={{ borderColor: `${it.color}55`, backgroundColor: `${it.color}12` }}>
                      <it.icon className="w-6 h-6" style={{ color: it.color }} />
                    </span>
                    <span className="min-w-0">
                      <span className="block font-mono text-xs uppercase tracking-wider text-muted-foreground">{it.label}</span>
                      <span className="block font-display font-bold text-white truncate">{it.value}</span>
                    </span>
                  </Comp>
                </motion.div>
              );
            })
          )}
        </div>
      </div>
    </div>
  );
}
